import { TradeOrderSideEnum } from '@sparling/financial-common'
import { RootState } from '../types'

export const orderSideSelector = (state: RootState): TradeOrderSideEnum => state.app.orderSide
export const authTokenSelector = (state: RootState): RootState['app']['authToken'] => state.app.authToken
export const redirectPathSelector = (state: RootState): RootState['app']['redirectPath'] => state.app.redirectPath
